import useTranslation, { type Translation } from "./use-translation";

type Props = {
	keyName: Translation;
};

export default function T({ keyName }: Props) {
	const t = useTranslation();
	return <>{t(keyName)}</>;
}
